import * as React from 'react';

function SvgRss(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M14 1a1 1 0 011 1v12a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h12zM2 0a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2H2z' />
			<path d='M5.5 12a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-3-8.5a1 1 0 011-1c5.523 0 10 4.477 10 10a1 1 0 11-2 0 8 8 0 00-8-8 1 1 0 01-1-1zm0 4a1 1 0 011-1 6 6 0 016 6 1 1 0 11-2 0 4 4 0 00-4-4 1 1 0 01-1-1z' />
		</svg>
	);
}

export default SvgRss;
